// extracted by mini-css-extract-plugin
export default {"wrapper":"SideNav_wrapper__CNMHz","active":"SideNav_active__naSwA","label":"SideNav_label__-1SLl"};